export default {
    data() {
        return {
            
        }
    },

    methods: {
        
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Content.js